import request from '@/utils/request'

export function getListLogByRegister(registerId) {
  return request({
    url: 'administration/getByRegister/' + registerId,
    method: 'get',
  });
}
